<template>
  <header class="navbar-fixed-top">
    <div class="service-link">
      <div class="container-wrap">
        <div class="clearfix">
          <div class="pull-left">
            <span>客服热线：400-898-9231</span>
            <div class="inline-block header-margin">
              <span>关注我们</span>
              <!--微信-->
              <el-popover placement="bottom" trigger="hover">
                <div slot="reference" class="inline-block margin-left-10 cursor-pointer">
                  <img :src="WeiXinIcon" alt="icon" />
                </div>
                <div>
                  <div class="text-center">
                    <img class="pover-img" :src="serviceQrCode" alt />
                    <br />
                    <span>好尔美服务号</span>
                  </div>
                  <div class="text-center margin-top-20">
                    <img class="pover-img" :src="subscribeQrCode" alt />
                    <br />
                    <span>好尔美订阅号</span>
                  </div>
                </div>
              </el-popover>
              <!--安卓-->
              <el-popover placement="bottom" trigger="hover">
                <div slot="reference" class="inline-block margin-left-10 cursor-pointer">
                  <img :src="android" alt="icon" />
                </div>
                <div>
                  <div class="text-center">
                    <!-- <img class="pover-img" :src="oldQrCode" alt=""><br> -->
                    <span>Android用户端</span>
                  </div>
                  <div class="text-center margin-top-20">
                    <!-- <img class="pover-img" :src="staffQrCode" alt=""><br> -->
                    <span>Android服务端</span>
                  </div>
                </div>
              </el-popover>
              <!--苹果-->
              <el-popover placement="bottom" trigger="hover">
                <div slot="reference" class="inline-block margin-left-10 cursor-pointer">
                  <img :src="iphone" alt="icon" />
                </div>
                <div>
                  <div class="text-center">
                    <!-- <img class="pover-img" :src="oldIOS" alt=""><br> -->
                    <span>IOS用户端</span>
                  </div>
                  <div class="text-center margin-top-20">
                    <!-- <img class="pover-img" :src="staffIOS" alt=""><br> -->
                    <span>IOS服务端</span>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>

          <div class="pull-right">
            <!-- <div class="pull-left clearfix">
              <i class="el-icon-mobile-phone"></i>
              <router-link class="cursor-pointer white-color" to="/phone-download">手机下载</router-link>
            </div>-->
            <div class="pull-left header-margin">
              <router-link class="cursor-pointer white-color" to="/tech-service/service-site">技术服务</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <nav class="nav-link">
      <div class="container-wrap">
        <ul class="nav-link-list">
          <router-link to="/home" tag="li">
            <h1 style="line-height: inherit; margin:0; font-size: inherit">
              <img class="inline-block img-logo" :src="logo" alt="好尔美" title="好尔美" />
            </h1>
          </router-link>
          <router-link to="/home" tag="li">首页</router-link>
          <router-link to="/about-us-list" tag="li">关于我们</router-link>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      WeiXinIcon: require("@/assets/img/wei-xin.png"),
      iphone: require("@/assets/img/iphone.png"),
      android: require("@/assets/img/android.png"),
      logo: require("@/assets/img/logo.png"),
      staffQrCode: require("@/assets/img/home/staff-qr-code.png"),
      oldQrCode: require("@/assets/img/home/old-qr-code.png"),
      serviceQrCode: require("@/assets/img/home/service_qr_code.png"),
      subscribeQrCode: require("@/assets/img/home/subscribe_qr_code.png"),
      oldIOS: require("@/assets/img/home/old-ios.png"),
      staffIOS: require("@/assets/img/home/staff-ios.png")
    };
  }
};
</script>

<style scoped>
.nav-mall:link,
.nav-mall:visited,
.nav-mall:hover,
.nav-mall:active {
  color: #332c2b;
}
.pover-img {
  width: 180px;
  height: 180px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.service-link {
  height: 30px;
  line-height: 30px;
  background: #3b6ba5;
  color: #fefefe;
  font-size: 0.14rem;
}
.nav-link-list {
  font-size: 0.16rem;
}
.nav-link-list .active-link {
  color: #336699;
  font-size: 0.16rem;
  font-weight: bold;
  /*background: #3b6ba5;*/
  /*color: #fefefe;*/
}
.nav-link {
  height: 60px;
  line-height: 60px;
  box-shadow: 1px 3px 6px #95a4a7;
  background: #fefefe;
}
.nav-link-list {
  text-align: center;
  margin-left: -100px;
  margin-right: -100px;
}
.nav-link-list li {
  display: inline-block;
  cursor: pointer;
  margin-left: 60px;
  margin-right: 60px;
  line-height: 18px;
}

/*.nav-link-list li:first-child{*/
/*margin-left: 0px;*/
/*}*/
/*.nav-link-list li:last-child{*/
/*margin-right: 0px;*/
/*}*/
.header-margin {
  margin-left: 100px;
}
.img-logo {
  width: 160px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue